export const environment = {
  production: true,
  uat: false,
  dev: false,
  apiUrl: 'https://receiving-manager-api.macmiller.com',
  qrLogReaderUrl: 'https://receiving-manager.macmiller.com',
  appUrl: 'https://receiving-manager.macmiller.com',
  redirectUri: 'https://receiving-manager.macmiller.com',
  logoutUrl: 'https://receiving-manager.macmiller.com',
  postLogoutRedirectUri: 'https://receiving-manager.macmiller.com',
  assets: './assets/',
  authority: 'https://login.microsoftonline.com/a4d2a09c-1ee5-4505-a0ae-73eed45d4091',
  clientId: 'c0640193-30e1-4bd8-aaba-8ad69577e636',
  apiScope: ["api://c0640193-30e1-4bd8-aaba-8ad69577e636/RM.ReadWrite", 
    "api://c0640193-30e1-4bd8-aaba-8ad69577e636/RM.Read"],
  // App-role 'value' strings as defined on the Entra app registration (App roles blade).
  // These must match the role Value exactly — they are what arrives in the token's 'roles' claim.
  AppRoleUser: 'general-app-access',
  AppRoleAdmin: 'admin-access',
  version: "v3.5.0",
  assetsVersion: "v3.2.0"
};
